import AliasEqualsConverter from '../AliasEqualsConverter';
export default AliasEqualsConverter.create('vehicle.color');